import * as React from "react";
import {
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Modal,
  Form,
  Input,
  Select
} from "antd";
const FormItem = Form.Item;
const { TextArea } = Input;

const Option = Select.Option;

import { connect } from "react-redux";

import { WordWrapProperty, TextAlignProperty } from "csstype";

interface ISecondaryConfirmProps {
  orderNo: any;
  searchOrder: any;
  // 二次确认 确认
  reconfirmOk: any;
  // 二次确认 拒绝
  reconfirmReject: any;
}

// 二次确认
class SecondaryConfirm extends React.Component<ISecondaryConfirmProps, any> {
  state = {
    visible: false,
    // 二次确认确认框显示状态
    modalVisible: false,
    // 二次确认拒绝框显示状态
    rejectVisible: false
  };

  constructor(props: ISecondaryConfirmProps) {
    super(props);
  }

  // 点击菜单触发的事件
  menuClick = data => {
    console.log("menuClick", data);
    switch (data.key) {
      case "1": //确认申请
        this.setState({
          modalVisible: true,
          visible: false
        });
        break;
      case "2": //拒绝申请
        this.setState({
          rejectVisible: true,
          visible: false
        });
        break;
      default:
        break;
    }
  };

  // 打开菜单
  open = () => {
    const data = this.props.orderNo;
    let visible = false;

    if (data && data.length !== 0) {
      visible = true;
    } else {
      visible = false;
      message.config({
        top: 100,
        duration: 2,
        maxCount: 1
      });
      message.warning("请选择订单");
    }

    this.setState({
      visible: visible
    });
  };

  menu = (
    <Menu onClick={this.menuClick}>
      <Menu.Item key="1">确认申请</Menu.Item>
      <Menu.Item key="2">拒绝申请</Menu.Item>
    </Menu>
  );

  onVisibleChange = visible => {
    if (!visible) {
      this.setState({
        visible
      });
    }
  };

  hideModalVisible = () => {
    this.setState({
      modalVisible: false,
      rejectVisible: false
    });
  };

  render() {
    const buttonStyle = {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <div className="button-group-child">
        <Dropdown
          trigger={["click"]}
          overlay={this.menu}
          onVisibleChange={this.onVisibleChange}
          visible={this.state.visible}
        >
          <Button type="primary" style={buttonStyle} onClick={this.open}>
            二次确认 <Icon type="down" />
          </Button>
        </Dropdown>
        <SecondaryConfirmModal
          title="确认申请"
          visible={this.state.modalVisible}
          hide={this.hideModalVisible}
          orderNo={this.props.orderNo}
          searchOrder={this.props.searchOrder}
          reconfirmOk={this.props.reconfirmOk}
        />
        <RejectApply
          visible={this.state.rejectVisible}
          hide={this.hideModalVisible}
          orderNo={this.props.orderNo}
          searchOrder={this.props.searchOrder}
          reconfirmReject={this.props.reconfirmReject}
        />
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    reconfirmOk: dispatch.orderInfo.reconfirmOk,
    reconfirmReject: dispatch.orderInfo.reconfirmReject
  };
};

export default connect(
  null,
  mapDispatch
)(SecondaryConfirm);

interface ISecondaryConfirmModalProps {
  reconfirmOk?: any;
  visible: any;
  // 隐藏模态框
  hide: any;
  orderNo: any;
  // 查询回调方法
  searchOrder: any;
  // 弹窗标题
  title?: any;
}

// 确认二次确认模态框
class SecondaryConfirmModal extends React.Component<
  ISecondaryConfirmModalProps,
  any
  > {
  state = { disabled: false, isRequest: false };

  constructor(props: ISecondaryConfirmModalProps) {
    super(props);
  }

  handleOk = e => {
    this.setState(
      {
        isRequest: true
      },
      () => {
        this.props.reconfirmOk({
          ids: this.props.orderNo.join(),
          callback: data => {
            if (data && data.error) {
              message.error(data.res.msg);
              this.setState({
                isRequest: false
              });
            } else {
              this.setState(
                {
                  isRequest: false
                },
                () => {
                  // this.props.searchOrder();
                }
              );
              this.props.hide();
              message.success("操作成功");
              this.props.searchOrder();
            }
          }
        });
      }
    );
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      disabled: false,
      isRequest: false
    });
    this.props.hide();
  };

  updateDisabled = () => {
    return this.state.disabled || this.state.isRequest;
  };

  bodyStyle = {
    padding: "24px",
    fontSize: "14px",
    lineHeight: "98px",
    minHeight: "140px",
    wordWrap: "break-word" as WordWrapProperty,
    textAlign: "center" as TextAlignProperty
  };

  render() {
    return (
      <Modal
        title={this.props.title || "提示"}
        bodyStyle={this.bodyStyle}
        visible={this.props.visible}
        destroyOnClose={true}
        keyboard={false}
        centered={true}
        onOk={this.handleOk}
        okButtonProps={{ disabled: this.updateDisabled() }}
        onCancel={this.handleCancel}
      >
        确认对订单二次确认吗？
      </Modal>
    );
  }
}

interface IRejectApplyProps {
  reconfirmReject: any;
  orderNo: any;
  searchOrder: any;
  visible: boolean;
  hide: any;
}

// 拒绝申请
class RejectApply extends React.Component<IRejectApplyProps, any> {
  state = { disabled: false, isRequest: false, formRef: null };

  constructor(props: IRejectApplyProps) {
    super(props);
  }

  updateDisabled = () => {
    return this.state.disabled || this.state.isRequest;
  };

  handleOk = (e: any) => {
    const formRef: any = this.state.formRef;
    if (formRef != null) {
      formRef.handleSubmit(e, formInfo => {
        if (!formInfo.error) {
          this.setState(
            {
              isRequest: true
            },
            () => {
              this.props.reconfirmReject({
                ids: this.props.orderNo.join(),
                ...formInfo.data,
                callback: data => {
                  if (data && data.error) {
                    message.error(data.res.msg);
                    this.setState({
                      isRequest: false
                    });
                  } else {
                    this.setState({
                      isRequest: false
                    });
                    this.props.hide();
                    message.success("操作成功");
                    this.props.searchOrder();
                  }
                }
              });
            }
          );
        }
      });
    }
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      disabled: false,
      isRequest: false
    });
    this.props.hide();
  };

  getFormRef = formRef => {
    this.setState({
      formRef
    });
  };

  render() {
    return (
      <Modal
        title="拒绝申请"
        visible={this.props.visible}
        destroyOnClose={true}
        keyboard={false}
        centered={true}
        onOk={this.handleOk}
        okButtonProps={{ disabled: this.updateDisabled() }}
        onCancel={this.handleCancel}
      >
        <FormRejectForm onRef={this.getFormRef} />
      </Modal>
    );
  }
}

interface IRejectFormProps {
  onRef: any;
  form: any;
}

// 拒绝申请表单
class RejectForm extends React.Component<IRejectFormProps, any> {
  constructor(props: IRejectFormProps) {
    super(props);
    this.props.onRef(this);
  }

  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 }
    }
  };

  handleSubmit = (e: any, cb: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        cb({ data: values });
      } else {
        cb({ error: err });
      }
    });
  };

  getFormItem = () => {
    const { getFieldDecorator } = this.props.form;
    const selectRules = {
      rules: [
        {
          required: true,
          message: "请输入取消原因!"
        }
      ]
    };

    const inputRules = {
      rules: [
        {
          required: true,
          transform: value => {
            return !!value ? value.trim() : null;
          },
          message: "请输入取消说明!"
        }
      ]
    };

    const select = getFieldDecorator("cancelWhy", selectRules)(
      <Select placeholder="请选择取消原因">
        <Option value="买卖双方协商一致">买卖双方协商一致</Option>
        <Option value="目的地不可抗因素">目的地不可抗因素</Option>
        <Option value="消费者信息填写错误">消费者信息填写错误</Option>
        <Option value="出团人数不足，无法成团">出团人数不足，无法成团</Option>
        <Option value="当前团期库存不足">当前团期库存不足</Option>
        <Option value="航班或酒店有变更">航班或酒店有变更</Option>
        <Option value="其他">其他</Option>
      </Select>
    );

    const input = getFieldDecorator("cancelContent", inputRules)(
      <TextArea
        placeholder="请输入取消说明"
        autosize={{ minRows: 10, maxRows: 16 }}
      />
    );

    let list: any = [];
    list.push(
      <FormItem key="0" {...this.formItemLayout} label="取消原因">
        {select}
      </FormItem>
    );

    list.push(
      <FormItem key="1" {...this.formItemLayout} label="取消说明">
        {input}
      </FormItem>
    );
    return list;
  };

  render() {
    return <Form>{this.getFormItem()}</Form>;
  }
}

const FormRejectForm = Form.create<any>()(RejectForm);
